module.exports = __webpack_public_path__ + "08b637d2a90152aad9c3c4a978a222a0.png";